import { MultiPolygon, Polygon } from 'geojson'
import { EditCoverageArea } from '~/components/editCoverageArea'
import {
  parseHealthProfessionalDelimitationKey,
} from '~/packages/publicHealth/healthProfessional/healthProfessionalDelimitation.shared'
import healthProfessionalFetchDefinition from '../fetch/healthProfessionalFetch.definition'
import healthProfessionalSmartMappingDefinition, {
  recommendedSmartMappingOptions,
} from '../smartMapping/healthProfessionalSmartMapping.definition'
import healthProfessionalEditCoverageAreaDefinition from './healthProfessionalEditCoverageArea.definition'

interface HealthProfessional {
  key: string
  cns: string
  name: string
  teamIne: string | null
  healthUnitCnes: string | null
  latitude: number
  longitude: number
  coverageArea: Polygon | MultiPolygon | null
  kind:
    | 'smartMapping'
    | 'deprecated'
    | 'manualDrawing'
    | 'authorityProvided'
    | 'openStreetMapSourced'
    | null
}

const EditCoverageAreaScreen = EditCoverageArea<
  HealthProfessional,
  typeof healthProfessionalFetchDefinition.input,
  typeof healthProfessionalFetchDefinition.output,
  typeof healthProfessionalEditCoverageAreaDefinition.input,
  typeof healthProfessionalEditCoverageAreaDefinition.output,
  typeof healthProfessionalSmartMappingDefinition.input,
  typeof healthProfessionalSmartMappingDefinition.output
>

export default function HealthProfessionalEditCoverageAreaScreen() {
  return (
    <EditCoverageAreaScreen
      editCoverageAreaDefinition={healthProfessionalEditCoverageAreaDefinition}
      fetchDefinition={healthProfessionalFetchDefinition}
      smartMappingDefinition={healthProfessionalSmartMappingDefinition}
      recommendedSmartMappingOptions={recommendedSmartMappingOptions}
      getSmartMappingBlockReason={delimitation => {
        if (!delimitation) {
          return 'Selecione uma equipe de saúde para executar o mapeamento inteligente'
        }

        const parsedDelimitation = parseHealthProfessionalDelimitationKey(delimitation.key ?? null)
        if (parsedDelimitation.scopeType !== 'healthTeam') {
          return 'Mapeamento inteligente de agentes exige delimitação por equipe de saúde'
        }

        return null
      }}
    />
  )
}
